import { generateId } from '@repo/shared/uuid/uuid'
import { useT } from '@repo/ui/hooks'
import { useEffect } from 'react'

import { PromptEditorLight } from '@/components/admin/PromptEditorLight'
import { AssistantWrapper } from '@/components/assistant/AssistantWrapper'
import { RightPanel } from '@/components/layouts/panels/RightPanel'
import { adminStoreActions, storeActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'
import { Organization } from '@/store/user'

export function DescriptionRoute({ organization }: { organization: Organization }) {
  const { tc, t } = useT({ keyPrefix: 'admin.description' })
  const dispatch = useStoreDispatch()
  const handlePromptUpdated = (description: string) => {
    void dispatch(
      adminStoreActions.organization.update({
        fields: { description },
      }),
    )
  }

  useEffect(() => {
    dispatch(
      storeActions.assistant.askFor.organization.description.start({
        generationId: generateId(),
      }),
    )
  }, [])
  return (
    <div className="grid grid-cols-2 gap-4 2xl:gap-6 w-full">
      <PromptEditorLight
        key="description"
        initialPrompt={organization.description}
        description={t('description')}
        onPromptUpdated={handlePromptUpdated}
        placeholder={t('placeholder')}
        title={tc('description', { cfl: true })}
      />

      <RightPanel
        className="max-w-full 2xl:max-w-full m-0 2xl:m-0 max-h-full overflow-hidden overflow-y-auto"
        status="fixed"
      >
        <AssistantWrapper />
      </RightPanel>
    </div>
  )
}
